module.exports = __webpack_public_path__ + "static/media/callgage-facebook.1de7ae62.svg";